export const Permissions = {
    ROLE_ATG_ADMIN: 'ROLE_ATG_ADMIN',
    ROLE_HOUSE_ADMIN: 'ROLE_HOUSE_ADMIN',
    ROLE_SUPER_USER: 'ROLE_SUPER_USER',
    ROLE_USER: 'ROLE_USER',
} as const;
